// TODO: [Sportybet]
export enum TransactionType {
  Deposit = 1,
  Withdrawal = 2,
  Bet = 3
}

export const RuleEngineTime = 3; // sec

// TODO: [Sportybet]
export enum Country {
  KE = 'ke',
  NG = 'ng',
  GH = 'gh',
  ZM = 'zm',
  TZ = 'tz',
  UG = 'ug',
  // New
  INT = 'int',
  CM = 'cm'
}
// TODO: [Sportybet]
export const CurrencyMap: Record<Country|string, string> = {
  [Country.KE]: 'KES',
  [Country.NG]: 'NGN',
  [Country.GH]: 'GHS',
  [Country.ZM]: 'ZMW',
  [Country.TZ]: 'TZS',
  [Country.UG]: 'UGX',
  [Country.INT]: 'TEST',
};
// TODO: [Sportybet]
export enum OrderType {
  Single = 1,
  Multiple = 2,
  System = 3
}

// Only Used in Native
export const MINIMIZE_TIME = 1140; // 19 min * 60 = 1140 sec

// Before, they has another provider zendesk
export enum CustomerServiceProvider {
  PLEASED = 'pleased',
}

export const MIN_DESCRIPTION_CHAR_NUM = 3;
export const MAX_DESCRIPTION_CHAR_NUM = 1800;

export const MAX_GUEST_FIELDS_CHAR = {
  name: 100,
  email: 100,
  phone: 20,
  description: MAX_DESCRIPTION_CHAR_NUM,
} as const;
